// extracted by mini-css-extract-plugin
export default {"Container":"Burger_Container__bBkWO","active":"Burger_active__6x37C"};